import { useState } from 'react';
import { createStore } from 'reusable';

export const useIsApiKeyModalIsOpen = createStore(() => useState(false));
